//const prefix = 'http://localhost:8012';
const prefix = window.location.protocol + '//' + window.location.host;

// Debounced function to limit API calls during typing
const debounce = (fn, delay) => {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, arguments), delay);
  };
};

function replaceWordsWithSpan(text, words) {
  // Create a regex pattern that matches both singular and plural forms
  const regex = new RegExp(`\\b(${words.join('|')})s?\\b`, 'gi');
  return text.replace(regex, (match) => `<b>${match}</b>`);
}

// Simplified search using the categorized endpoint
const searchWpCategorized = async (text) => {
  // Apply the same word expansion logic as in search.php
  const wordExpansions = {
    'bank': ['bank', 'banks', 'banking', 'banked'],
    'banks': ['bank', 'banks', 'banking', 'banked'],
    'banking': ['bank', 'banks', 'banking', 'banked'],
    'banked': ['bank', 'banks', 'banking', 'banked'],
    'loan': ['loan', 'loans', 'lending', 'lend'],
    'loans': ['loan', 'loans', 'lending', 'lend'],
    'lending': ['loan', 'loans', 'lending', 'lend'],
    'lend': ['loan', 'loans', 'lending', 'lend'],
    'mortgage': ['mortgage', 'mortgages', 'home loan'],
    'mortgages': ['mortgage', 'mortgages', 'home loan'],
    'credit': ['credit', 'credits', 'lending'],
    'credits': ['credit', 'credits', 'lending'],
    'account': ['account', 'accounts', 'checking', 'savings'],
    'accounts': ['account', 'accounts', 'checking', 'savings'],
    'checking': ['account', 'accounts', 'checking', 'savings'],
    'savings': ['account', 'accounts', 'checking', 'savings'],
    'card': ['card', 'cards', 'debit', 'credit card'],
    'cards': ['card', 'cards', 'debit', 'credit card'],
    'debit': ['card', 'cards', 'debit', 'credit card'],
    'invest': ['invest', 'investment', 'investments', 'investing'],
    'investment': ['invest', 'investment', 'investments', 'investing'],
    'investments': ['invest', 'investment', 'investments', 'investing'],
    'investing': ['invest', 'investment', 'investments', 'investing'],
    'retire': ['retire', 'retirement', 'retiring', 'retired'],
    'retirement': ['retire', 'retirement', 'retiring', 'retired'],
    'retiring': ['retire', 'retirement', 'retiring', 'retired'],
    'retired': ['retire', 'retirement', 'retiring', 'retired'],
    'business': ['business', 'commercial', 'corporate'],
    'commercial': ['business', 'commercial', 'corporate'],
    'corporate': ['business', 'commercial', 'corporate'],
    'personal': ['personal', 'individual', 'consumer'],
    'individual': ['personal', 'individual', 'consumer'],
    'consumer': ['personal', 'individual', 'consumer'],
    'business': ['business', 'businesses'],
    'businesses': ['business', 'businesses'],
    'login': ['login', 'logins', 'log in'],
    'logins': ['login', 'logins', 'log in'],
    'log in': ['login', 'logins', 'log in'],
    '401': ['401', '401k', '401(k)', '401 k'],
    '401k': ['401', '401k', '401(k)', '401 k'],
    '401(k)': ['401', '401k', '401(k)', '401 k'],
    '401 k': ['401', '401k', '401(k)', '401 k'],
    'payment': ['payment', 'payments'],
    'payments': ['payment', 'payments'],
    'finance': ['finance', 'finances', 'financial', 'financed'],
    'finances': ['finance', 'finances', 'financial', 'financed'],
    'financial': ['finance', 'finances', 'financial', 'financed'],
    'financed': ['finance', 'finances', 'financial', 'financed'],
  };

  const words = text.toLowerCase().split(' ');
  const expandedTerms = [];

  words.forEach(word => {
    word = word.trim();
    if (wordExpansions[word]) {
      expandedTerms.push('(' + wordExpansions[word].join(' OR ') + ')');
    } else {
      expandedTerms.push(word);
    }
  });

  const expandedQuery = expandedTerms.join(' AND ');

  // Use the categorized endpoint that returns results already organized by taxonomy
  return fetch(`${prefix}/wp-json/wesbanco-search/v1/autocomplete-categorized?search=${encodeURIComponent(expandedQuery)}&per_page=12`)
    .then(r => r.json())
    .catch(error => {
      console.error('Search API error:', error);
      return {
        'wb-tag': [],
        'document-type': [],
        'product': [],
        'other': []
      };
    });
}

async function addAutoComplete(searchEl) {
  const searchForm = searchEl?.closest('form')

  if (!searchEl || !searchForm) {
    console.warn({ searchEl, parentForm: searchForm });
    return;
  }

  searchForm.style.position = 'relative';
  searchEl.setAttribute('autocomplete', 'off');
  searchEl.classList.add('autocomplete-input');

  const autoCompleteElement = document.createElement('div');
  autoCompleteElement.classList.add('autocomplete-taxonomy')
  searchForm.appendChild(autoCompleteElement)

  let searchVal = '';
  let canSearch = false;

  const searchInterval = setInterval(() => {
    if (!canSearch) return;
    canSearch = false;

    searchWpCategorized(searchVal).then((topResultsByTaxonomy) => {
      console.log("Categorized Search Results: ", topResultsByTaxonomy);

      updateSize();
      openAutoComplete({ topResultsByTaxonomy, searchVal });
    });
  }, 700);

  const closeAutoComplete = () => {
    autoCompleteElement.dataset['open'] = false;
  }

  const updateSize = () => {
    const rect = searchForm.getBoundingClientRect();
    autoCompleteElement.style.width = `${rect.width + 10}px`;
    autoCompleteElement.style.top = `${rect.height + 5}px`;
    autoCompleteElement.style.left = `-5px`;
  }

  const openAutoComplete = ({ topResultsByTaxonomy, searchVal }) => {
    autoCompleteElement.dataset['open'] = true;
    const searchWords = searchVal.split(' ').filter(l => l.length > 0);
    let view = '';

    // Define taxonomy display names (matching your search interface)
    const taxonomyNames = {
      'wb-tag': 'Education & Insights',
      'document-type': 'Tools & Calculators',
      'product': 'Products',
      'other': 'Other'
    };

    Object.entries(topResultsByTaxonomy).forEach(([taxonomyKey, resultList]) => {
      if (resultList.length === 0) return;

      const taxName = taxonomyNames[taxonomyKey] || taxonomyKey;

      const sectionMarkup = `
        <div data-name="${taxonomyKey}">
          <div class="autocomplete-section-title">${taxName}</div>
          <ul class="autocomplete">
            ${resultList.map(result => `
              <li>
                <a href="${result.url}" title="${result.title}">
                  ${result.title}
                </a>
              </li>`).join('')}
          </ul>
        </div>
      `;
      view += sectionMarkup;
    });

    if (view) {
      autoCompleteElement.innerHTML = view;
      requestAnimationFrame(() => {
        autoCompleteElement.querySelectorAll('a').forEach(anchor => {
          anchor.innerHTML = replaceWordsWithSpan(anchor.innerHTML, searchWords);
        });
      });
    } else {
      autoCompleteElement.innerHTML = `<div class="no-results">
        <div>No results found for <b>${searchVal}</b></div>
        <div>
          <ul>
            <li><a href="/education-insights/">Education and Insights</a></li>
            <li><a href="/education-insights/banking-tools-and-calculators/">Tools and Calculators</a></li>
            <li><a href="/products/">Products</a></li>
          </ul>
        </div>
      </div>`;
    }
  }

  searchEl.addEventListener('input', debounce(function(inputEvent) {
    canSearch = searchEl.value.length > 0 && searchVal !== searchEl.value;
    searchVal = searchEl.value;
    if (searchVal.length === 0) {
      closeAutoComplete();
    }
  }, 300));

  window.addEventListener('resize', () => {
    updateSize();
  });

  return {
    closeAutoComplete,
    openAutoComplete,
    updateSize,
  }
}

export default {
  addAutoComplete,
  searchWp: searchWpCategorized,
}
